<template>
  <div
    v-if="loading2"
    class="loadingBox"
    v-loading="true"
    :element-loading-text="lNum + '%'"
  >
    <!-- <div class="loading"><img src="../../../assets/loading.gif" alt="" /></div> -->
    <!-- <div>{{ lNum }}%</div> -->
  </div>
</template>

<script>
export default {
  props: ["isLoading"],
  data() {
    return {
      lNum: 0,
      timmer: null,
      loading2: false,
      timeout: null,
    };
  },
  watch: {
    isLoading: {
      handler: function (newVal, oldVal) {
        if (newVal) {
          if (this.timeout) {
            this.timeout = null;
            clearTimeout(this.timeout);
          }
          this.lNum = 1;
          this.loading2 = true;
          this.setTime();
        } else {
          if (this.timmer) {
            clearInterval(this.timmer);
          }
          this.lNum = 100;
          this.timeout = setTimeout(() => {
            this.loading2 = false;
          }, 1000);
        }
      },
      deep: true,
    },
  },
  methods: {
    setTime() {
      let count = 1;
      this.timmer = setInterval(() => {
        count++;
        let persent = parseInt(((count / 90) * 100).toFixed(0));
        if (persent == 0) {
          this.lNum = 1;
        } else if (0 < persent < 100) {
          this.lNum = persent;
        } else if (persent >= 100) {
          this.lNum = 99;
        }
      }, 1000);
    },
  },
  beforeDestroy() {
    if (this.timmer) {
      clearInterval(this.timmer);
    }
  },
  mounted() {
    // if (this.isLoading) {
    //   this.loading2 = true;
    //   this.setTime();
    // } else {
    //   if (this.timmer) {
    //     clearInterval(this.timmer);
    //   }
    //   this.lNum = 100;
    //   this.timeout = setTimeout(() => {
    //     this.loading2 = false;
    //   }, 1000);
    // }
  },
};
</script>

<style scoped>
.loadingBox {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  /* background: #8d8d8d8f; */
  z-index: 999;
  border-radius: 8px;
  overflow: hidden;
}
.loading {
  width: 100px;
  height: 100px;
}
.loading > img {
  width: 100%;
  height: 100%;
}

.loadingBox >>> .el-loading-mask {

}
</style>


// WEBPACK FOOTER //
// src/components/pages/components/loading.vue